import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Icone } from '../icones';

export interface ItemRotina {
  codigo: string;
  nome: string;
  icone?: string | null;
  /** Texto secundário à direita do nome (ex.: o módulo, num recente). */
  detalhe?: string;
}

export interface ListaRotinasProps {
  itens: ItemRotina[];
  /** O ui/ não conhece o roteador: a página entrega o link já montado, com a classe e o conteúdo recebidos. */
  link: (item: ItemRotina, props: { className: string; children: ReactNode }) => ReactNode;
  rotulo?: string;
  /** Mostra a seta de "abrir" no fim da linha. */
  seta?: boolean;
}

/** Lista de rotinas em linhas (início, painel do módulo): ícone, nome e o código como informação secundária. */
export function ListaRotinas({ itens, link, rotulo, seta = false }: ListaRotinasProps) {
  return (
    <ul className="lista-rotinas" aria-label={rotulo}>
      {itens.map((i) => (
        <li key={i.codigo}>
          {link(i, {
            className: 'lista-rotinas-item',
            children: (
              <>
                {/* Sem ícone próprio, um marcador neutro: repetir o mesmo ícone genérico em toda linha vira ruído (WWDC25 356). */}
                <span className="lista-rotinas-icone" data-vazio={i.icone ? undefined : true}>{i.icone && <Icone nome={i.icone} size={15} />}</span>
                <span className="lista-rotinas-nome">{i.nome}</span>
                {i.detalhe && <span className="lista-rotinas-detalhe">{i.detalhe}</span>}
                <span className="mono lista-rotinas-codigo">{i.codigo}</span>
                {seta && <ChevronRight size={14} className="lista-rotinas-seta" aria-hidden="true" />}
              </>
            ),
          })}
        </li>
      ))}
    </ul>
  );
}
